<script lang="ts" setup>
import { inject } from 'vue';

import type { Ref } from 'vue';

const skyBoxFile = inject('skyBoxFile') as Ref<string>;
const availableSkyBoxes = new Set<string>(__SKYBOXES__);
</script>

<template>
  <div class="flex flex-row mb-1 items-center">
    <label for="skybox-file" class="text-xs mr-2">Cube</label>
    <select v-model="skyBoxFile" class="text-xs flex-grow border bg-white p-1 max-w-[231px]">
      <option v-for="availableSkyBox in availableSkyBoxes" :key="availableSkyBox" :value="availableSkyBox">
        {{ availableSkyBox }}
      </option>
    </select>
  </div>
  <p v-if="!availableSkyBoxes.has(skyBoxFile)" class="text-xs text-red-500 mb-1">
    Value from the manifest is not available as a skybox option.<br>
    <b class="text-black">Current value: {{ skyBoxFile }}</b>
  </p>
</template>
